import React, { useState } from 'react';
import { IoClose } from 'react-icons/io5';

import * as S from './styles';
import { BannersCarroselProps } from 'types/BannersCarroselProps';
import ConfirmScreen from 'components/ConfirmScreen';

interface ListBannersProps {
	list: BannersCarroselProps[];
	getBannerToEdit: any;
	deleteBanner: any;
}

export default function ListBanners({
	list,
	getBannerToEdit,
	deleteBanner
}: ListBannersProps) {
	const [isOpenBoxToDelete, setIsOpenToDelete] = useState(false);
	const [bannerToDelete, setBannerToDelete] =
		useState<null | BannersCarroselProps>(null);

	return (
		<S.container>
			{list.length === 0 ? (
				<S.emptyList>
					<p>Não há banners cadastrados</p>
				</S.emptyList>
			) : (
				<S.list>
					{list.map((item) => (
						<S.item key={item.id}>
							<IoClose
								onClick={() => {
									setBannerToDelete(item);
									setIsOpenToDelete(true);
								}}
							/>
							<S.content
								onClick={() => {
									getBannerToEdit(item);
								}}
							>
								<img src={item.urlBanner} alt={item.name} title={item.name} />
								<p>{item.name}</p>
							</S.content>
						</S.item>
					))}
				</S.list>
			)}

			<ConfirmScreen
				title="Tela de confirmação"
				isOpen={isOpenBoxToDelete}
				setIsOpen={setIsOpenToDelete}
				buttonClose={false}
				functioToExecOnClose={() => {}}
				functionToExecOnConfirm={async () => {
					const isSuccess = await deleteBanner(bannerToDelete);

					if (isSuccess) {
						setBannerToDelete(null);
						setIsOpenToDelete(false);
					}
				}}
				message={
					<p>
						Tem certeza que deseja deletar o banner
						<b> {` "${bannerToDelete?.name || 'Sem nome'}"`}</b>.
					</p>
				}
			/>
		</S.container>
	);
}
